var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.993,
    height: 13.885,
    viewBox: "0 0 42.993 13.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M5991.879,2145.272l-5.625,13.429h-3.672l-2.771-10.72a1.479,1.479,0,0,0-.826-1.18,14.685,14.685,0,0,0-3.427-1.143l.082-.386h5.912a1.622,1.622,0,0,1,1.6,1.366l1.462,7.77,3.614-9.137Zm14.391,9.044c.016-3.545-4.9-3.744-4.868-5.325.012-.482.471-.994,1.473-1.126a6.576,6.576,0,0,1,3.428.6l.609-2.85a9.418,9.418,0,0,0-3.249-.593c-3.436,0-5.851,1.823-5.87,4.439-.022,1.932,1.724,3.011,3.039,3.653,1.355.658,1.809,1.081,1.8,1.67-.008.9-1.082,1.3-2.078,1.315a7.263,7.263,0,0,1-3.569-.849l-.629,2.942a10.547,10.547,0,0,0,3.862.715c3.649,0,6.037-1.806,6.05-4.594m9.069,4.385h3.211l-2.808-13.429h-2.962a1.579,1.579,0,0,0-1.479.984l-5.21,12.445h3.645l.725-2.007h4.457Zm-3.88-4.76,1.829-5.042,1.055,5.042Zm-14.615-8.669-2.872,13.429H5990.5l2.872-13.429Z",
    transform: "translate(-5975.558 -2145.026)",
    fill: "#5c70ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9dfa28284c22216cec64dacd9392649b.svg";
export { ForwardRef as ReactComponent };